var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-toast',{attrs:{"id":"toast-selfie","auto-hide-delay":7500,"toaster":"b-toaster-top-center toast-selfie"}},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"mr-3"},[_c('Icon',{staticClass:"icon-circle",attrs:{"name":"infoCircle","width":"32"}})],1),_c('div',{staticClass:"text-left",domProps:{"innerHTML":_vm._s(_vm.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }